import React from 'react'
import type { IChatHeader } from 'features/Chat/Chat.types'
import getChatHeaderSecondaryText from 'features/Chat/utils/getChatHeaderSecondaryText'
import ChatHeader from '../ChatHeader'

export interface Props {
	className?: string
	chatHeaders: IChatHeader[]
	userId: string
	currentEventId: string
	showSelected?: boolean
	onClick: any
	/** Passed through to each row. See ChatHeader for what 'rail' does. */
	variant?: 'default' | 'rail'
}

const ChatHeaderList = ({
	className = '',
	chatHeaders,
	userId,
	currentEventId,
	showSelected = true,
	onClick,
	variant = 'default',
}: Props) => {
	return (
		<div data-testid="ChatHeaderList" className={className}>
			{chatHeaders.length > 0 && (
				<ul className="list-none p-0 m-0">
					{chatHeaders.map((chatHeader, index) => {
						return (
							<li key={index}>
								<ChatHeader
									avatars={chatHeader.avatars}
									primaryText={chatHeader.label}
									secondaryText={getChatHeaderSecondaryText(
										chatHeader.message,
										chatHeader.lastMessage,
										userId,
									)}
									isSelected={showSelected && chatHeader._id === currentEventId}
									isUnread={!chatHeader.readByIds.includes(userId)}
									onClick={() => onClick(chatHeader)}
									variant={variant}
								/>
							</li>
						)
					})}
				</ul>
			)}
		</div>
	)
}

export default ChatHeaderList
